import { useContext } from "react";
import { AuthorizedUserContext } from "./AuthorizedUserProvider/context";

// NOTE: AuthorizedGuard で認証を済んでいることを前提に、認証済みの User を返却する
export const useAuthorizedUser = () => {
  const context = useContext(AuthorizedUserContext);

  if (context === undefined) {
    throw new Error("AuthorizedUserContext が見つかりません");
  }

  return context;
};
